import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useSelector } from 'react-redux';

import SearchForm from './SearchForm';
import ResultsGrid from '../ext/ResultsGrid';
import WipoResultsGrid from '../WIPO/WipoResultsGrid';

const AdressResults = () => {
  const { results, loading, error } = useSelector((s) => s.search);
  const { lastSearchQuery } = useSelector((s) => s.tz);
  const wipoLastSearchQuery = useSelector((s) => s.wipo.lastSearchQuery);
  const [, setLocalState] = useState({
    previewSrc: null,
    originalPreviewSrc: null,
    croppedBlob: null,
    cropConfig: null,
    fileName: null,
  });

  const items = [
    {
      key: 'adress',
      label: 'ТЗ',
      children: (
        <ResultsGrid
          items={results.adress}
          loading={loading.adress}
          error={error.adress}
          loadingTip="Поиск ТЗ по адресу…"
          errorTitle="Ошибка ТЗ"
          emptyTitle="ТЗ не найдены"
          requestType="По адресу (ТЗ)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'adressReq',
      label: 'Заявки',
      children: (
        <ResultsGrid
          items={results.adressReq}
          loading={loading.adressReq}
          error={error.adressReq}
          loadingTip="Поиск заявок по адресу…"
          errorTitle="Ошибка заявок"
          emptyTitle="Заявок не найдено"
          requestType="По адресу (заявки)"
          searchQuery={lastSearchQuery}
        />
      )
    },
    {
      key: 'wipo',
      label: 'WIPO',
      children: (
        <WipoResultsGrid
          items={results.wipoAdres}
          loading={loading.wipoAdres}
          error={error.wipoAdres}
          loadingTip="Поиск WIPO по адресу…"
          errorTitle="Ошибка WIPO"
          emptyTitle="Не найдено"
          requestType="WIPO: Адрес"
          searchQuery={wipoLastSearchQuery}
        />
      )
    }
  ];

  return (
    <div style={{ width: '100%', padding: 16 }}>
      <SearchForm setLocalState={setLocalState} />
      <Tabs defaultActiveKey="adress" destroyInactiveTabPane={false} items={items} />
    </div>
  );
};

export default AdressResults;
